import { render, staticRenderFns } from "./BlockListBorgerMicroArticleCustom.vue?vue&type=template&id=0461a6ee&"
import script from "./BlockListBorgerMicroArticleCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListBorgerMicroArticleCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports